import { render, staticRenderFns } from "./notifications-modal.vue?vue&type=template&id=acff05f6&scoped=true&"
import script from "./notifications-modal.vue?vue&type=script&lang=js&"
export * from "./notifications-modal.vue?vue&type=script&lang=js&"
import style0 from "./notifications-modal.vue?vue&type=style&index=0&id=acff05f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acff05f6",
  null
  
)

export default component.exports